
import { Component } from 'nuxt-property-decorator'
import { Articolo } from '~/types/models/Articolo'
import SeoMetaComponent from '@/components/classes/meta'
import { Asset } from '~/types/models/Asset'

@Component
export default class ArticoloPage extends SeoMetaComponent {
  public item: Articolo | null = null
  public lightboxMedia: any = []
  public toggleLightbox: boolean = false
  public startAtIndex: number = 0

  mounted() {}

  async fetch() {
    try {
      const { data } = await this.$axios.get(
        'articoli/' + this.$route.params.slug
      )
      this.item = data as Articolo
      this.loadMeta({
        titolo: data.titolo,
        contenuto: data.abstract,
        image: this.getImage(),
        slug: 'news-eventi/' + this.$route.params.slug,
      })

      if (this.item?.gallery) {
        this.mountLightBox(this.item.gallery)
      }
    } catch (error: any) {
      if (error?.response?.status === 404) {
        this.$nuxt.error({
          statusCode: error?.response?.status,
          message: 'News non trovata',
        })
      } else {
        this.$nuxt.error({
          statusCode: 500,
        })
      }

      throw error
    }
  }

  fetchOnServer() {
    return true
  }

  public mountLightBox(gallery: Asset[]) {
    if (!gallery?.length) return
    this.lightboxMedia = gallery?.map((image: any) => {
      return {
        type: 'image',
        thumb: this.$config.cdnEndpoint + 128 + '/' + image.originalName,
        src: this.$config.cdnEndpoint + 1024 + '/' + image.originalName,
        srcset:
          this.$config.cdnEndpoint +
          512 +
          '/' +
          image.originalName +
          ' 480w, ' +
          this.$config.cdnEndpoint +
          1024 +
          '/' +
          image.originalName +
          ' 1200w, ' +
          this.$config.cdnEndpoint +
          2048 +
          '/' +
          image.originalName +
          ' 2000w',
      }
    })
  }

  public getImage() {
    if (!this.item?.mainImage) {
      return '/img/blog-11.jpg'
    }
    const image = this.item?.mainImage
    return this.$config.cdnEndpoint + '1024/' + image.originalName
  }

  public getCurrentLink(): string {
    if (process.client) {
      return window.location.href
    }
    return '#'
  }

  public calculateCols() {
    if (this.item?.gallery === undefined) {
      return 12
    }
    if (this.item?.gallery?.length > 3) {
      return 3
    }
    if (this.item?.gallery.length === 3) {
      return 4
    }
    return 2
  }

  openLightbox(e: any, index: number) {
    e.preventDefault()
    this.startAtIndex = index
    this.toggleLightbox = true
  }

  public onLightboxClosed() {
    this.toggleLightbox = false
  }
}
